import {
  Order,
  Lender,
  Document,
  Note,
  StatusHistory,
  PayoffCompany,
  InsuranceCompany,
  AgentContact,
  TitleCompany,
  TitleContact,
} from '../types'

export const mockPayoffCompanies: PayoffCompany[] = [
  {
    id: 'pc-1',
    name: 'First National Mortgage',
    phone: '(212) 555-0100',
    email: 'payoffs@firstnational.com',
    isAutomated: true,
  },
  {
    id: 'pc-2',
    name: 'Liberty Home Loans',
    phone: '(312) 555-0200',
    email: 'servicing@libertyhome.com',
    isAutomated: false,
  },
  {
    id: 'pc-3',
    name: 'Coastal Bank & Trust',
    phone: '(305) 555-0300',
    email: 'payoff.dept@coastalbank.com',
    isAutomated: true,
  },
  {
    id: 'pc-4',
    name: 'Mountain View Credit Union',
    phone: '(303) 555-0400',
    email: 'loans@mountainviewcu.org',
    isAutomated: false,
  },
  {
    id: 'pc-5',
    name: 'Horizon Financial Services',
    phone: '(206) 555-0500',
    email: 'payoff.requests@horizonfs.com',
    isAutomated: true,
  },
  {
    id: 'pc-6',
    name: 'SunTrust Solar Finance',
    phone: '(404) 555-0600',
    email: 'payoffs@suntrustsolr.com',
    isAutomated: false,
  },
]

export const mockInsuranceCompanies: InsuranceCompany[] = [
  {
    id: 'ic-1',
    name: 'State Farm Insurance',
    phone: '(800) 782-8332',
    email: 'claims@statefarm.com',
  },
  {
    id: 'ic-2',
    name: 'Allstate Insurance',
    phone: '(800) 255-7828',
    email: 'service@allstate.com',
  },
  {
    id: 'ic-3',
    name: 'Liberty Mutual',
    phone: '(800) 290-8711',
    email: 'service@libertymutual.com',
  },
  {
    id: 'ic-4',
    name: 'Farmers Insurance',
    phone: '(888) 327-6335',
    email: 'service@farmers.com',
  },
  {
    id: 'ic-5',
    name: 'Nationwide Insurance',
    phone: '(877) 669-6877',
    email: 'service@nationwide.com',
  },
]

export const mockAgentContacts: AgentContact[] = [
  {
    id: 'agent-1',
    name: 'Tom Richards',
    phone: '(212) 555-1001',
    email: 'tom.richards@statefarm.com',
    companyId: 'ic-1',
  },
  {
    id: 'agent-2',
    name: 'Sarah Mitchell',
    phone: '(312) 555-2002',
    email: 'sarah.mitchell@allstate.com',
    companyId: 'ic-2',
  },
  {
    id: 'agent-3',
    name: 'David Park',
    phone: '(305) 555-3003',
    email: 'david.park@libertymutual.com',
    companyId: 'ic-3',
  },
  {
    id: 'agent-4',
    name: 'Lisa Chen',
    phone: '(206) 555-4004',
    email: 'lisa.chen@farmers.com',
    companyId: 'ic-4',
  },
  {
    id: 'agent-5',
    name: 'Mark Johnson',
    phone: '(303) 555-5005',
    email: 'mark.johnson@nationwide.com',
    companyId: 'ic-5',
  },
]

export const mockTitleCompanies: TitleCompany[] = [
  {
    id: 'tc-1',
    name: 'Premier Title Services',
    phone: '(312) 555-7001',
    email: 'orders@premiertitle.com',
    address: '100 Title Way, Chicago, IL 60601',
  },
  {
    id: 'tc-2',
    name: 'Secure Title Company',
    phone: '(303) 555-7002',
    email: 'orders@securetitle.com',
    address: '200 Escrow Blvd, Denver, CO 80202',
  },
  {
    id: 'tc-3',
    name: 'National Title Group',
    phone: '(212) 555-7003',
    email: 'orders@nationaltitle.com',
    address: '300 Settlement Ave, New York, NY 10001',
  },
  {
    id: 'tc-4',
    name: 'Heritage Title Services',
    phone: '(305) 555-7004',
    email: 'orders@heritagetitle.com',
    address: '400 Deed St, Miami, FL 33101',
  },
]

export const mockTitleContacts: TitleContact[] = [
  {
    id: 'tcontact-1',
    name: 'Rachel Green',
    phone: '(312) 555-7101',
    email: 'rachel.green@premiertitle.com',
    companyId: 'tc-1',
  },
  {
    id: 'tcontact-2',
    name: 'Mike Torres',
    phone: '(303) 555-7102',
    email: 'mike.torres@securetitle.com',
    companyId: 'tc-2',
  },
  {
    id: 'tcontact-3',
    name: 'Jennifer Wu',
    phone: '(212) 555-7103',
    email: 'jennifer.wu@nationaltitle.com',
    companyId: 'tc-3',
  },
  {
    id: 'tcontact-4',
    name: 'Carlos Rivera',
    phone: '(305) 555-7104',
    email: 'carlos.rivera@heritagetitle.com',
    companyId: 'tc-4',
  },
]

export const mockLenders: Lender[] = [
  {
    id: 'lender-1',
    name: 'First National Mortgage',
    fhaSponsorId: 'FHA-12345',
    vaSponsorId: 'VA-67890',
    taxId: '12-3456789',
    insuranceMortgageeClause:
      'First National Mortgage, ISAOA/ATIMA, 123 Main St, New York, NY 10001',
    titleMortgageeClause:
      'First National Mortgage, Its Successors and/or Assigns',
    address: {
      street: '123 Main Street',
      city: 'New York',
      state: 'NY',
      zip: '10001',
    },
    phone: '(212) 555-0100',
    email: 'payoffs@firstnational.com',
    createdAt: '2024-01-15T10:00:00Z',
    updatedAt: '2024-01-15T10:00:00Z',
  },
  {
    id: 'lender-2',
    name: 'Liberty Home Loans',
    fhaSponsorId: 'FHA-54321',
    vaSponsorId: 'VA-09876',
    taxId: '98-7654321',
    insuranceMortgageeClause:
      'Liberty Home Loans, ISAOA/ATIMA, 456 Oak Ave, Chicago, IL 60601',
    titleMortgageeClause: 'Liberty Home Loans, Its Successors and/or Assigns',
    address: {
      street: '456 Oak Avenue',
      city: 'Chicago',
      state: 'IL',
      zip: '60601',
    },
    phone: '(312) 555-0200',
    email: 'servicing@libertyhome.com',
    createdAt: '2024-02-01T14:30:00Z',
    updatedAt: '2024-02-01T14:30:00Z',
  },
  {
    id: 'lender-3',
    name: 'Coastal Bank & Trust',
    fhaSponsorId: 'FHA-11223',
    vaSponsorId: 'VA-44556',
    taxId: '45-6789012',
    insuranceMortgageeClause:
      'Coastal Bank & Trust, ISAOA/ATIMA, 789 Beach Blvd, Miami, FL 33101',
    titleMortgageeClause: 'Coastal Bank & Trust, Its Successors and/or Assigns',
    address: {
      street: '789 Beach Boulevard',
      city: 'Miami',
      state: 'FL',
      zip: '33101',
    },
    phone: '(305) 555-0300',
    email: 'payoff.dept@coastalbank.com',
    createdAt: '2024-01-20T09:15:00Z',
    updatedAt: '2024-01-20T09:15:00Z',
  },
  {
    id: 'lender-4',
    name: 'Mountain View Credit Union',
    fhaSponsorId: 'FHA-99887',
    vaSponsorId: 'VA-77665',
    taxId: '23-4567890',
    insuranceMortgageeClause:
      'Mountain View Credit Union, ISAOA/ATIMA, 321 Summit Dr, Denver, CO 80202',
    titleMortgageeClause:
      'Mountain View Credit Union, Its Successors and/or Assigns',
    address: {
      street: '321 Summit Drive',
      city: 'Denver',
      state: 'CO',
      zip: '80202',
    },
    phone: '(303) 555-0400',
    email: 'loans@mountainviewcu.org',
    createdAt: '2024-02-10T11:45:00Z',
    updatedAt: '2024-02-10T11:45:00Z',
  },
  {
    id: 'lender-5',
    name: 'Horizon Financial Services',
    fhaSponsorId: 'FHA-33445',
    vaSponsorId: 'VA-22334',
    taxId: '67-8901234',
    insuranceMortgageeClause:
      'Horizon Financial Services, ISAOA/ATIMA, 555 Skyline Pkwy, Seattle, WA 98101',
    titleMortgageeClause:
      'Horizon Financial Services, Its Successors and/or Assigns',
    address: {
      street: '555 Skyline Parkway',
      city: 'Seattle',
      state: 'WA',
      zip: '98101',
    },
    phone: '(206) 555-0500',
    email: 'payoff.requests@horizonfs.com',
    createdAt: '2024-01-25T16:20:00Z',
    updatedAt: '2024-01-25T16:20:00Z',
  },
]

export const mockOrders: Order[] = [
  {
    id: 'order-1',
    loanId: 'loan-001',
    loanNumber: 'LN-2024-001',
    loanName: 'Smith Primary Residence Refi',
    borrowerName: 'John Smith',
    orderType: 'payoff',
    status: 'complete',
    assignedTo: 'Sarah Johnson',
    createdAt: '2024-02-01T09:00:00Z',
    updatedAt: '2024-02-15T14:30:00Z',
    payoffOrderedDate: '2024-02-01',
    payoffCompletedDate: '2024-02-15',
    goodThroughDate: '2024-03-15',
    existingLoanNumber: '123456789',
    lienPosition: '1st',
    liabilityType: 'Real Estate',
    payoffCompanyId: 'pc-1',
    payoffCompanyPhone: '(212) 555-0100',
    payoffCompanyEmail: 'payoffs@firstnational.com',
    isAutomated: true,
    borrowersAuthAttached: true,
  },
  {
    id: 'order-2',
    loanId: 'loan-001',
    loanNumber: 'LN-2024-001',
    loanName: 'Smith Primary Residence Refi',
    borrowerName: 'John Smith',
    orderType: 'insurance',
    status: 'reviewed',
    assignedTo: 'Sarah Johnson',
    createdAt: '2024-02-03T10:15:00Z',
    updatedAt: '2024-02-16T11:20:00Z',
    loanType: 'Refinance',
    chosenLenderId: 'lender-1',
    insuranceType: 'HOI',
    insuranceCompanyId: 'ic-1',
    agentContactId: 'agent-1',
    agentPhone: '(212) 555-1001',
    agentEmail: 'tom.richards@statefarm.com',
    mortgageeClause:
      'First National Mortgage, ISAOA/ATIMA, 123 Main St, New York, NY 10001',
    hoiEffectiveDate: '2024-02-03',
    policyNumber: 'SF-987654321',
    insuranceBorrowersAuthAttached: true,
  },
  {
    id: 'order-3',
    loanId: 'loan-002',
    loanNumber: 'LN-2024-002',
    loanName: 'Garcia Purchase - Chicago',
    borrowerName: 'Maria Garcia',
    orderType: 'title',
    status: 'received',
    assignedTo: 'Michael Chen',
    createdAt: '2024-02-05T13:45:00Z',
    updatedAt: '2024-02-14T09:10:00Z',
    chosenLenderId: 'lender-2',
    borrowerDob: '1985-06-15',
    borrowerLast4SSN: '4532',
    titleCompanyId: 'tc-1',
    titleContactId: 'tcontact-1',
    titleContactPhone: '(312) 555-7101',
    titleContactEmail: 'rachel.green@premiertitle.com',
    titleMortgageeClause: 'Liberty Home Loans, Its Successors and/or Assigns',
  },
  {
    id: 'order-4',
    loanId: 'loan-003',
    loanNumber: 'LN-2024-003',
    loanName: 'Lee HELOC',
    borrowerName: 'David Lee',
    orderType: 'appraisal',
    status: 'complete',
    assignedTo: 'Emily Rodriguez',
    createdAt: '2024-01-28T08:30:00Z',
    updatedAt: '2024-02-10T15:45:00Z',
    appraiser: 'ABC Appraisal Group',
    propertyAddress: '456 Oak Street, Chicago, IL 60601',
    valuLinkId: 'VL-2024-789',
    appraisalOrderDate: '2024-01-28',
  },
  {
    id: 'order-5',
    loanId: 'loan-004',
    loanNumber: 'LN-2024-004',
    loanName: 'Wilson Cash-Out Refi',
    borrowerName: 'Jennifer Wilson',
    orderType: 'payoff',
    status: 'pending',
    assignedTo: 'Sarah Johnson',
    createdAt: '2024-02-12T11:00:00Z',
    updatedAt: '2024-02-13T10:15:00Z',
    payoffOrderedDate: '2024-02-12',
    payoffCompletedDate: '',
    goodThroughDate: '2024-03-20',
    existingLoanNumber: '987654321',
    lienPosition: '2nd',
    liabilityType: 'HELOC',
    payoffCompanyId: 'pc-2',
    payoffCompanyPhone: '(312) 555-0200',
    payoffCompanyEmail: 'servicing@libertyhome.com',
    isAutomated: false,
    borrowersAuthAttached: true,
  },
  {
    id: 'order-6',
    loanId: 'loan-005',
    loanNumber: 'LN-2024-005',
    loanName: 'Taylor Coastal Purchase',
    borrowerName: 'Robert Taylor',
    orderType: 'insurance',
    status: 'ordered',
    assignedTo: 'Michael Chen',
    createdAt: '2024-02-15T14:20:00Z',
    updatedAt: '2024-02-15T14:20:00Z',
    loanType: 'Purchase',
    chosenLenderId: 'lender-3',
    insuranceType: 'Flood',
    insuranceCompanyId: 'ic-2',
    agentContactId: 'agent-2',
    agentPhone: '(312) 555-2002',
    agentEmail: 'sarah.mitchell@allstate.com',
    mortgageeClause:
      'Coastal Bank & Trust, ISAOA/ATIMA, 789 Beach Blvd, Miami, FL 33101',
    hoiEffectiveDate: '2024-03-01',
    policyNumber: '',
    insuranceBorrowersAuthAttached: false,
  },
  {
    id: 'order-7',
    loanId: 'loan-006',
    loanNumber: 'LN-2024-006',
    loanName: 'Anderson Mountain Property',
    borrowerName: 'Lisa Anderson',
    orderType: 'title',
    status: 'pending',
    assignedTo: 'Emily Rodriguez',
    createdAt: '2024-02-10T09:30:00Z',
    updatedAt: '2024-02-12T16:40:00Z',
    chosenLenderId: 'lender-4',
    borrowerDob: '1990-11-22',
    borrowerLast4SSN: '8871',
    titleCompanyId: 'tc-2',
    titleContactId: 'tcontact-2',
    titleContactPhone: '(303) 555-7102',
    titleContactEmail: 'mike.torres@securetitle.com',
    titleMortgageeClause:
      'Mountain View Credit Union, Its Successors and/or Assigns',
  },
  {
    id: 'order-8',
    loanId: 'loan-007',
    loanNumber: 'LN-2024-007',
    loanName: 'Martinez Denver Purchase',
    borrowerName: 'James Martinez',
    orderType: 'appraisal',
    status: 'received',
    assignedTo: 'Sarah Johnson',
    createdAt: '2024-02-08T10:45:00Z',
    updatedAt: '2024-02-14T13:20:00Z',
    appraiser: 'Precision Appraisals Inc',
    propertyAddress: '789 Maple Ave, Denver, CO 80202',
    valuLinkId: 'VL-2024-890',
    appraisalOrderDate: '2024-02-08',
  },
  {
    id: 'order-9',
    loanId: 'loan-008',
    loanNumber: 'LN-2024-008',
    loanName: 'Brown Investment Property',
    borrowerName: 'Patricia Brown',
    orderType: 'payoff',
    status: 'reviewed',
    assignedTo: 'Michael Chen',
    createdAt: '2024-02-06T15:10:00Z',
    updatedAt: '2024-02-15T11:30:00Z',
    payoffOrderedDate: '2024-02-06',
    payoffCompletedDate: '',
    goodThroughDate: '2024-03-10',
    existingLoanNumber: '555666777',
    lienPosition: '1st',
    liabilityType: 'Real Estate',
    payoffCompanyId: 'pc-3',
    payoffCompanyPhone: '(305) 555-0300',
    payoffCompanyEmail: 'payoff.dept@coastalbank.com',
    isAutomated: true,
    borrowersAuthAttached: true,
  },
  {
    id: 'order-10',
    loanId: 'loan-009',
    loanNumber: 'LN-2024-009',
    loanName: 'Davis Refi - Seattle',
    borrowerName: 'Christopher Davis',
    orderType: 'insurance',
    status: 'complete',
    assignedTo: 'Emily Rodriguez',
    createdAt: '2024-01-30T12:00:00Z',
    updatedAt: '2024-02-12T14:15:00Z',
    loanType: 'Refinance',
    chosenLenderId: 'lender-5',
    insuranceType: 'HOI',
    insuranceCompanyId: 'ic-3',
    agentContactId: 'agent-3',
    agentPhone: '(305) 555-3003',
    agentEmail: 'david.park@libertymutual.com',
    mortgageeClause:
      'Horizon Financial Services, ISAOA/ATIMA, 555 Skyline Pkwy, Seattle, WA 98101',
    hoiEffectiveDate: '2024-01-30',
    policyNumber: 'LM-789012345',
    insuranceBorrowersAuthAttached: true,
  },
  {
    id: 'order-11',
    loanId: 'loan-010',
    loanNumber: 'LN-2024-010',
    loanName: 'White First-Time Buyer',
    borrowerName: 'Amanda White',
    orderType: 'title',
    status: 'ordered',
    assignedTo: 'Sarah Johnson',
    createdAt: '2024-02-16T08:45:00Z',
    updatedAt: '2024-02-16T08:45:00Z',
    chosenLenderId: 'lender-1',
    borrowerDob: '1978-03-09',
    borrowerLast4SSN: '2210',
    titleCompanyId: 'tc-3',
    titleContactId: 'tcontact-3',
    titleContactPhone: '(212) 555-7103',
    titleContactEmail: 'jennifer.wu@nationaltitle.com',
    titleMortgageeClause:
      'First National Mortgage, Its Successors and/or Assigns',
  },
  {
    id: 'order-12',
    loanId: 'loan-011',
    loanNumber: 'LN-2024-011',
    loanName: 'Thompson Seattle Purchase',
    borrowerName: 'Daniel Thompson',
    orderType: 'appraisal',
    status: 'pending',
    assignedTo: 'Michael Chen',
    createdAt: '2024-02-14T13:20:00Z',
    updatedAt: '2024-02-15T09:50:00Z',
    appraiser: 'Elite Property Valuations',
    propertyAddress: '321 Pine St, Seattle, WA 98101',
    valuLinkId: 'VL-2024-901',
    appraisalOrderDate: '2024-02-14',
  },
  {
    id: 'order-13',
    loanId: 'loan-012',
    loanNumber: 'LN-2024-012',
    loanName: 'Harris Solar Loan',
    borrowerName: 'Michelle Harris',
    orderType: 'payoff',
    status: 'ordered',
    assignedTo: 'Emily Rodriguez',
    createdAt: '2024-02-17T10:30:00Z',
    updatedAt: '2024-02-17T10:30:00Z',
    payoffOrderedDate: '2024-02-17',
    payoffCompletedDate: '',
    goodThroughDate: '2024-03-25',
    existingLoanNumber: '111222333',
    lienPosition: '2nd',
    liabilityType: 'Solar',
    payoffCompanyId: 'pc-6',
    payoffCompanyPhone: '(404) 555-0600',
    payoffCompanyEmail: 'payoffs@suntrustsolr.com',
    isAutomated: false,
    borrowersAuthAttached: false,
  },
  {
    id: 'order-14',
    loanId: 'loan-013',
    loanNumber: 'LN-2024-013',
    loanName: 'Clark Chicago Purchase',
    borrowerName: 'Kevin Clark',
    orderType: 'insurance',
    status: 'received',
    assignedTo: 'Sarah Johnson',
    createdAt: '2024-02-11T14:15:00Z',
    updatedAt: '2024-02-16T10:25:00Z',
    loanType: 'Purchase',
    chosenLenderId: 'lender-2',
    insuranceType: 'Flood',
    insuranceCompanyId: 'ic-4',
    agentContactId: 'agent-4',
    agentPhone: '(206) 555-4004',
    agentEmail: 'lisa.chen@farmers.com',
    mortgageeClause:
      'Liberty Home Loans, ISAOA/ATIMA, 456 Oak Ave, Chicago, IL 60601',
    hoiEffectiveDate: '2024-03-15',
    policyNumber: 'FI-234567890',
    insuranceBorrowersAuthAttached: true,
  },
  {
    id: 'order-15',
    loanId: 'loan-014',
    loanNumber: 'LN-2024-014',
    loanName: 'Lewis Refi - Miami',
    borrowerName: 'Nancy Lewis',
    orderType: 'title',
    status: 'reviewed',
    assignedTo: 'Michael Chen',
    createdAt: '2024-02-09T11:40:00Z',
    updatedAt: '2024-02-16T15:10:00Z',
    chosenLenderId: 'lender-3',
    borrowerDob: '1982-08-30',
    borrowerLast4SSN: '6654',
    titleCompanyId: 'tc-4',
    titleContactId: 'tcontact-4',
    titleContactPhone: '(305) 555-7104',
    titleContactEmail: 'carlos.rivera@heritagetitle.com',
    titleMortgageeClause: 'Coastal Bank & Trust, Its Successors and/or Assigns',
  },
  {
    id: 'order-16',
    loanId: 'loan-015',
    loanNumber: 'LN-2024-015',
    loanName: 'Walker Miami Condo',
    borrowerName: 'Steven Walker',
    orderType: 'appraisal',
    status: 'ordered',
    assignedTo: 'Emily Rodriguez',
    createdAt: '2024-02-16T09:00:00Z',
    updatedAt: '2024-02-16T09:00:00Z',
    appraiser: 'Metro Appraisal Services',
    propertyAddress: '654 Elm Dr, Miami, FL 33101',
    valuLinkId: 'VL-2024-912',
    appraisalOrderDate: '2024-02-16',
  },
  {
    id: 'order-17',
    loanId: 'loan-016',
    loanNumber: 'LN-2024-016',
    loanName: 'Young Primary Refi',
    borrowerName: 'Karen Young',
    orderType: 'payoff',
    status: 'complete',
    assignedTo: 'Sarah Johnson',
    createdAt: '2024-02-04T08:20:00Z',
    updatedAt: '2024-02-14T16:45:00Z',
    payoffOrderedDate: '2024-02-04',
    payoffCompletedDate: '2024-02-14',
    goodThroughDate: '2024-03-05',
    existingLoanNumber: '444555666',
    lienPosition: '1st',
    liabilityType: 'Real Estate',
    payoffCompanyId: 'pc-5',
    payoffCompanyPhone: '(206) 555-0500',
    payoffCompanyEmail: 'payoff.requests@horizonfs.com',
    isAutomated: true,
    borrowersAuthAttached: true,
  },
  {
    id: 'order-18',
    loanId: 'loan-017',
    loanNumber: 'LN-2024-017',
    loanName: 'Hall Denver Refi',
    borrowerName: 'Brian Hall',
    orderType: 'insurance',
    status: 'pending',
    assignedTo: 'Michael Chen',
    createdAt: '2024-02-13T15:30:00Z',
    updatedAt: '2024-02-15T12:40:00Z',
    loanType: 'Refinance',
    chosenLenderId: 'lender-4',
    insuranceType: 'HOI',
    insuranceCompanyId: 'ic-5',
    agentContactId: 'agent-5',
    agentPhone: '(303) 555-5005',
    agentEmail: 'mark.johnson@nationwide.com',
    mortgageeClause:
      'Mountain View Credit Union, ISAOA/ATIMA, 321 Summit Dr, Denver, CO 80202',
    hoiEffectiveDate: '2024-02-13',
    policyNumber: '',
    insuranceBorrowersAuthAttached: true,
  },
]

export const mockStatusHistory: StatusHistory[] = [
  {
    id: 'hist-1',
    orderId: 'order-1',
    status: 'ordered',
    updatedBy: 'Sarah Johnson',
    updatedAt: '2024-02-01T09:00:00Z',
  },
  {
    id: 'hist-2',
    orderId: 'order-1',
    status: 'pending',
    updatedBy: 'Sarah Johnson',
    updatedAt: '2024-02-05T10:30:00Z',
    notes: 'Waiting for lender response',
  },
  {
    id: 'hist-3',
    orderId: 'order-1',
    status: 'received',
    updatedBy: 'Sarah Johnson',
    updatedAt: '2024-02-10T14:15:00Z',
    notes: 'Payoff statement received via email',
  },
  {
    id: 'hist-4',
    orderId: 'order-1',
    status: 'reviewed',
    updatedBy: 'Michael Chen',
    updatedAt: '2024-02-12T11:20:00Z',
    notes: 'Verified payoff amount and good through date',
  },
  {
    id: 'hist-5',
    orderId: 'order-1',
    status: 'complete',
    updatedBy: 'Sarah Johnson',
    updatedAt: '2024-02-15T14:30:00Z',
    notes: 'Uploaded to loan file',
  },
]

export const mockDocuments: Document[] = [
  {
    id: 'doc-1',
    orderId: 'order-1',
    fileName: 'borrower_authorization.pdf',
    fileSize: 245000,
    folder: 'borrowers_auth',
    uploadedBy: 'Sarah Johnson',
    uploadedAt: '2024-02-01T09:15:00Z',
    url: '#',
  },
  {
    id: 'doc-2',
    orderId: 'order-1',
    fileName: 'payoff_statement.pdf',
    fileSize: 189000,
    folder: 'vendor_review',
    uploadedBy: 'System',
    uploadedAt: '2024-02-10T14:20:00Z',
    url: '#',
  },
  {
    id: 'doc-3',
    orderId: 'order-1',
    fileName: 'final_payoff_statement.pdf',
    fileSize: 189000,
    folder: 'order_documents',
    uploadedBy: 'Sarah Johnson',
    uploadedAt: '2024-02-15T14:35:00Z',
    url: '#',
  },
  {
    id: 'doc-4',
    orderId: 'order-2',
    fileName: 'insurance_authorization.pdf',
    fileSize: 156000,
    folder: 'borrowers_auth',
    uploadedBy: 'Sarah Johnson',
    uploadedAt: '2024-02-03T10:20:00Z',
    url: '#',
  },
  {
    id: 'doc-5',
    orderId: 'order-2',
    fileName: 'hoi_policy_declaration.pdf',
    fileSize: 412000,
    folder: 'order_documents',
    uploadedBy: 'Sarah Johnson',
    uploadedAt: '2024-02-16T11:25:00Z',
    url: '#',
  },
]

export const mockNotes: Note[] = [
  {
    id: 'note-1',
    orderId: 'order-1',
    content: 'Called lender to request expedited payoff statement',
    author: 'Sarah Johnson',
    createdAt: '2024-02-03T14:30:00Z',
  },
  {
    id: 'note-2',
    orderId: 'order-1',
    content: 'Lender confirmed they will email statement by end of week',
    author: 'Sarah Johnson',
    createdAt: '2024-02-03T14:35:00Z',
  },
  {
    id: 'note-3',
    orderId: 'order-1',
    content: 'Payoff statement received and uploaded for review',
    author: 'Sarah Johnson',
    createdAt: '2024-02-10T14:25:00Z',
  },
  {
    id: 'note-4',
    orderId: 'order-2',
    content: 'Sent authorization to State Farm via email',
    author: 'Sarah Johnson',
    createdAt: '2024-02-03T10:30:00Z',
  },
  {
    id: 'note-5',
    orderId: 'order-2',
    content: 'Policy declaration received, verifying mortgagee clause',
    author: 'Michael Chen',
    createdAt: '2024-02-16T11:15:00Z',
  },
]
